import React, {useState, useEffect, useMemo, useRef, useCallback} from 'react';
import '../../../../asset/styles/customer-profile-style.css';
import api from '../../../../../apis';

import moment from 'moment';
import {useLoading} from '../../../../../context/LoadingContext';
import {useLocation, useNavigate} from 'react-router-dom';
import {
    convertPositiveNumberHundred, getNavItemById,
    handlePositiveNumberChange,
    handlePositiveNumberHundredChange,
    handleSelectChange
} from "../../../../general/general-tools";
import ReactTable from "../../../../general/form-control/react-table";



const UserTypeList = React.memo(props => {

    let setCurrentPage = props['setCurrentPage']== null ? '' : props['setCurrentPage'];
    let setCurrentPerPage = props['setCurrentPerPage']== null ? '' : props['setCurrentPerPage'];
    let currentPage = props['tableData']== null ? '' : props['currentPage'];
    let currentPerPage = props['tableData']== null ? '' : props['currentPerPage'];
    let totalRecords = props['tableData']== null ? '' : props['totalRecords'];
    let setCurrentUsrTypeId = props['setCurrentUsrTypeId']== null ? '' : props['setCurrentUsrTypeId'];

    let tableData = props['tableData']== null ? '' : props['tableData'];
    let popupManager = props['popupManager']== null ? '' : props['popupManager'];


    const handleOnclick = async (row) => {
        await setLoading(true);

        if(setCurrentUsrTypeId)setCurrentUsrTypeId(row.ut_id ?? 0);

        // navigate("/" + process.env.REACT_APP_URL_PREFIX + "br_entry_opr", {
        //     state: {
        //         row: row,
        //         perm: actualPerm,
        //         mode: 'Edit'
        //     }
        // });
        setLoading(false);
    };


    const columns = useMemo(
        () => [

            {
                id: row => row.ut_name,
                name: 'User Type',
                selector: row => row.ut_name,
                sortable: true,
                // center: true,
                cell: (row: { ut_name: any }) => (
                    <>
                        <a className="tableItemsHlink" onClick={() => handleOnclick(row)}>{row.ut_name}</a>
                    </>
                )
            },
            {
                name: 'User Category',
                selector: row => row.uc_name,
                sortable: true,
            }
        ],
        []
    );



    return  <>

        <ReactTable
            rowClick={setCurrentPage}
            perPageQty={setCurrentPerPage}
            // handleSelect={setCurrentUsrTypeId}
            columns={columns}
            data={tableData}
            pagination={{
                currentPage: currentPage,
                totalRecords: totalRecords,
                currentPerPage: currentPerPage,
                // selectableHandle: {setCurrentUsrTypeId},
            }}
        />

    </>
});
export default UserTypeList;
